<section class="auth-page">
  <app-auth-banner></app-auth-banner>
  <div class="auth-page__form">
    <app-sign-up-form></app-sign-up-form>
  </div>
</section>
